export default function (state = {}, action) {
	switch (action.type) {
		case 'ADD_FEATURE_SOURCE':
		case 'UPDATE_FEATURE_SOURCE':
			return {
				...state,
				[action.key]: {
					data: action.data,
					lastUpdate: Date.now(),
				},
			};
		case 'EMPTY_FEATURE_SOURCE':
			return {...state, [action.key]: []};
		case 'DELETE_FEATURE_SOURCE':
			return {...state, [action.key]: undefined}; // TODO: test if works
		default:
			return state;
	}
}
